import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import RTModal from '../common/RTModal';
import RTButton from '../common/RTButton';
import { apiPost } from '../../api/apiClient';
import { toastError, toastSuccess } from '../common/toast';
import { formatDateToDDMMYYYY } from '../../utils/dateHelper';
import 'react-datepicker/dist/react-datepicker.css';
import './PGPortal.css';

function startOfToday() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

function addDays(d, days) {
  const next = new Date(d);
  next.setDate(next.getDate() + days);
  return next;
}

function toYmd(d) {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

const PGNoticeModal = ({ isOpen, onClose, onSuccess }) => {
  const [noticeDate, setNoticeDate] = useState(startOfToday);
  const [minEndDate, setMinEndDate] = useState(() => addDays(startOfToday(), 30));
  const [endDate, setEndDate] = useState(() => addDays(startOfToday(), 30));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const notice = startOfToday();
    const minEnd = addDays(notice, 30);
    setNoticeDate(notice);
    setMinEndDate(minEnd);
    setEndDate(minEnd);
  }, [isOpen]);

  const handleSubmit = async () => {
    if (!endDate) {
      toastError('Please select an end date.');
      return;
    }
    if (endDate < minEndDate) {
      toastError('End date cannot be less than 30 days from today.');
      return;
    }
    try {
      setLoading(true);
      const payload = {
        notice_date: toYmd(noticeDate),
        end_date: toYmd(endDate),
      };
      const res = await apiPost('/pg/me/allocation/notice', payload);
      toastSuccess(res.data?.message || 'Notice submitted.');
      onSuccess?.(res.data?.allocation);
      onClose();
    } catch (err) {
      toastError(err.response?.data?.detail || 'Failed to submit notice.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <RTModal isOpen={isOpen} onClose={onClose} title="Notice to Vacate" size="medium">
      <div className="pg-modal-body">
        <div className="pg-alert">
          Your stay will end on <strong>{formatDateToDDMMYYYY(endDate)}</strong>.
          End date cannot be earlier than 30 days from today.
        </div>

        <div className="pg-row">
          <span className="pg-row-label">Notice date</span>
          <span className="pg-row-value">{formatDateToDDMMYYYY(noticeDate)}</span>
        </div>

        <div className="pg-form-group" style={{ marginTop: 12 }}>
          <label>End date</label>
          <DatePicker
            selected={endDate}
            onChange={setEndDate}
            dateFormat="dd/MM/yyyy"
            minDate={minEndDate}
            placeholderText="DD/MM/YYYY"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
          />
        </div>

        <p className="pg-muted" style={{ marginTop: 4, marginBottom: 0 }}>
          Any changes to date needs to be updated and approved by management.
        </p>

        <div className="pg-actions">
          <RTButton variant="primary" onClick={handleSubmit} disabled={loading}>
            {loading ? 'Submitting…' : 'Confirm notice'}
          </RTButton>
          <RTButton variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </RTButton>
        </div>
      </div>
    </RTModal>
  );
};

export default PGNoticeModal;
